import React from 'react';

import { DataCenterSection } from '@/components/wpl/pricing/src/data-center/data-center-section';
import { PricingFeatureTable } from '@/components/wpl/pricing/src/features-table/features-table';
import {
	useDatacenterPlans,
	usePricingContentContext,
} from '@/components/wpl/pricing/src/pricing-content-context.tsx';
import { PricingFaq } from '@/components/wpl/pricing/src/pricing-faq/pricing-faq';
import { QuotationsAdornment } from '@/components/wpl/pricing/src/pricing-faq/quotations';
import { PageHeading } from '@/components/wpl/pricing/src/pricing-page-layout/page-heading';
import { PricingPageLayout } from '@/components/wpl/pricing/src/pricing-page-layout/pricing-page-layout';
import { QuestionsCta } from '@/components/wpl/pricing/src/questions-cta';
import { BitbucketNav } from '@/templates/software/bitbucket/src/sections/bitbucket-navbar';
import { CallToAction } from '@/utils/pricing-queries/get-pricing-content-gql.ts';
import { ParentScrollTracking } from '@/utils/scroll-tracking/parent-scroll-tracker.tsx';

import { SoftwareBitbucketPricingPageProps } from '../../../../../../pages/software/bitbucket/pricing/software-bitbucket-pricing-page';

import { BitbucketPriceFinder } from './sections/bitbucket-price-finder.tsx';

export const SoftwareBitbucketPricingPageTemplate: React.FC<
	SoftwareBitbucketPricingPageProps
	// eslint-disable-next-line complexity
> = ({ pricing, countryCode }) => {
	const content = usePricingContentContext();
	const dataCenterContent = useDatacenterPlans('Contact Us', 'Learn more');
	const questionsCtaContent = content?.callToActionContainer?.[0] as CallToAction;
	return (
		<PricingPageLayout nav={<BitbucketNav />} showFallback={content?.hasError}>
			<ParentScrollTracking pageId="bitbucket-pricing-page">
				<PageHeading>{content?.headline}</PageHeading>
				<BitbucketPriceFinder
					serverSideHAMSPricing={pricing?.hamsPricingData?.bitbucket}
					countryCode={countryCode}
				/>
				<PricingFeatureTable
					title={content?.compareFeaturesTitle ?? undefined}
					comparePlans={content?.comparePlans ?? undefined}
					compareFeatures={content?.compareFeatures ?? undefined}
				/>
				<DataCenterSection {...dataCenterContent} />
				<QuotationsAdornment>
					<ParentScrollTracking>
						<PricingFaq
							header={content?.getMoreDetailsTitle ?? undefined}
							planDetails={content?.additionalDetails ?? undefined}
						/>
					</ParentScrollTracking>
				</QuotationsAdornment>
				<QuestionsCta
					product={'Bitbucket'}
					ctaHref={questionsCtaContent?.url ?? undefined}
					questionsHeader={questionsCtaContent?.title ?? undefined}
					priceAndLicensingLinkText={questionsCtaContent?.text ?? undefined}
					questionsBody={questionsCtaContent?.valueProposition ?? undefined}
					imageHref={questionsCtaContent?.asset?.url}
				/>
			</ParentScrollTracking>
		</PricingPageLayout>
	);
};
